/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { login } from "../core/_requests";
import { useAuth } from "../core/Auth";
import { useDispatch, useSelector } from "react-redux";
import { TOKEN, ROLE, AppState, LANGUAGE , NAVIGATION} from "../../../../redux/types";
import { toAbsoluteUrl } from "../../../../_private/helpers";
import { setLanguage } from '../../../../_private/i18n/Metronici18n';
const languages = [
  {
    lang: "en",
    name: "English",
    flag: toAbsoluteUrl("/media/flags/united-states.svg"),
  },
  {
    lang: "ko",
    name: "Korean",
    flag: toAbsoluteUrl("/media/flags/south-korea.svg"),
  },
];

const loginSchema = Yup.object().shape({
	email: Yup.string().min(3, "Minimum 3 symbols").max(50, "Maximum 50 symbols").required("Username is required"),
	password: Yup.string().min(3, "Minimum 3 symbols").max(50, "Maximum 50 symbols").required("Password is required"),
	language_id: Yup.string(),
	language: Yup.string(),
});

const initialValues = {
	email: "",
	password: "",
	language_id: "",
	language: "",
};

export function Login() {
	//dispatch function for action dispatch to redux
	const dispatch = useDispatch();
	const language = useSelector((state: AppState) => state.language);
	
	//const lang = useLang();
	// const currentLanguage = languages.find((x) => x.lang === lang);
	const [loading, setLoading] = useState(false);
	const { saveAuth, setCurrentUser } = useAuth();

	const [passwordShown, setPasswordShown] = useState(false);
	const togglePasswordVisiblity = () => {
	  setPasswordShown(passwordShown ? false : true);
	};

	const formik = useFormik({
		initialValues,
		validationSchema: loginSchema,
		onSubmit: async (values, { setStatus, setSubmitting }) => {
			setLoading(true);
			try {
				window.localStorage.setItem('super-admin', "0")
				const { data: auth } = await login(values.email, values.password);
				const data = auth;
				const navigation = data?.navigation?.filter((item) => 
					typeof item?.is_check == 'boolean' && item?.is_check
				);
				if (data.navigation.length === 0) {
					window.localStorage.setItem('super-admin', "1")
				} else {
					window.localStorage.setItem('super-admin', "0")
				}
				saveAuth(auth);
				console.log(auth);
				dispatch({
					type: TOKEN,
					payload: auth.token,
				});
				dispatch({
					type: ROLE,
					payload: "superadmin",
				});
				dispatch({
					type: NAVIGATION,
					payload: navigation,
				});
				setCurrentUser(auth);
			} catch (error) {
				console.error(error);
				saveAuth(undefined);
				setStatus("The login details are incorrect");
				setSubmitting(false);
				setLoading(false);
			}
		},
	});

	return (
		<form className='form w-100 main_log' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form'>
			{/* begin::Heading */}
			<div className='text-center mb-11'>
				<h1 className='fw-bolder mb-3 plex_txt' style={{color:"#181c32"}}>SLOTSDIAMOND 3
</h1>
				<div className="text-gray-500 fw-semibold fs-6">Welcome To Our Admin Panel</div>
			</div>
			{formik.status ? (
				<div className='mb-lg-15 alert alert-danger'>
					<div className='alert-text font-weight-bold'>{formik.status}</div>
				</div>
			) : (
				""
				// <div className='mb-10 bg-light-info p-8 rounded'>
				// 	<div className='text-info'>
				// 		Use account <strong>superadmin</strong> and password <strong>123456</strong> to continue.
				// 	</div>
				// </div>
			)}

			{/* begin::Form group */}
			<div className='fv-row mb-8 '>
				{/* <label className='form-label fs-6 fw-bolder text-dark'>Username</label> */}
				<input
					placeholder='Username'
					{...formik.getFieldProps("email")}
					className={clsx(
						"form-control bg-transparent",
						{ "is-invalid": formik.touched.email && formik.errors.email },
						{
							"is-valid": formik.touched.email && !formik.errors.email,
						}
					)}
					type='email'
					name='email'
					autoComplete='off'
				/>
				{formik.touched.email && formik.errors.email && (
					<div className='fv-plugins-message-container'>
						<span role='alert'>{formik.errors.email}</span>
					</div>
				)}
			</div>
			{/* end::Form group */}

			{/* begin::Form group */}
			<div className="fv-row">
        <div className="mb-1">
          {/* <label className="form-label fw-bolder text-dark fs-6 mb-0">
            Password
          </label> */}
          <div className="position-relative mb-3">
            <input
              type={passwordShown ? "text" : "password"}
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password ? <></> : (
              <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-2">
                {passwordShown ? (<i className="ki-duotone ki-eye fs-1" onClick={togglePasswordVisiblity}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </i>) : (
                  <i className="ki-duotone ki-eye-slash fs-1" onClick={togglePasswordVisiblity}>
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                  </i>
                )}
              </span>
            )}
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span style={{color:"#071437"}}>{formik.errors.password}</span>
              </div>
            </div>
          )}
        </div>
      </div>
			{/* end::Form group */}

			{/* begin::Wrapper */}
			<div className='d-flex flex-stack flex-wrap gap-3'>
				<div className='flex-start d-flex flex-stack'>
					<div>
						<button
							type='button'
							className='btn btn-flex btn-link btn-color-gray-700 btn-active-color-primary fs-base'
							data-kt-menu-trigger='click'
							data-kt-menu-placement='bottom'
						>
							<img
								id='current-lang-flag'
								data-kt-element='current-lang-flag'
								className='w-20px h-20px rounded me-3'
								src={language.flag}
								alt=''
							/>
							<span id='current-lang-name' data-kt-element='current-lang-name' className='me-1'>
								{language.name}
							</span>
							<i className='ki-duotone ki-down fs-5 text-muted rotate-180 m-0'></i>
						</button>

						<div
							className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-4 fs-7'
							data-kt-menu='true'
							id='kt_auth_lang_menu'
						>
							{languages.map((l) => (
								<div
									className='menu-item px-3'
									key={l.lang}
									onClick={() => {
										setLanguage(l.lang);
										// Swal.fire({
										//   icon: "success",
										//   title: `Switched to ${l.name}`,
										// });
										window.location.reload();
										const details = {
											lang: l.lang || null,
											name: l.name || null,
											flag: l.flag || null,
										};
										//console.log(details);
										localStorage.setItem("HQ_LANG_CHANGE_FLAG", "1");
										dispatch({
											type: LANGUAGE,
											payload: details,
										});
									}}>
									<Link to='#' className={clsx("menu-link d-flex px-5", { active: l.lang === language?.lang })}>
										<span className='symbol symbol-20px me-4'>
											<img className='rounded-1' src={l.flag} alt='metronic' />
										</span>
										{l.name}
									</Link>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			
						
			{/* end::Wrapper */}

			{/* begin::Action */}
			<div className='d-grid mb-10'>
				<button type='submit' id='kt_sign_in_submit' className='btn kt_sign_in_submit' disabled={formik.isSubmitting || !formik.isValid}>
					{!loading && <span className='indicator-label'>Sign In</span>}
					{loading && (
						<span className='indicator-progress' style={{ display: "block" }}>
							Please wait...
							<span className='spinner-border spinner-border-sm align-middle ms-2'></span>
						</span>
					)}
				</button>
			</div>
			{/* end::Action */}

			{/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div> */}
		</form>
	);
}
